import { __extends } from "tslib";
var WixHeadersParsingError = /** @class */ (function (_super) {
    __extends(WixHeadersParsingError, _super);
    function WixHeadersParsingError(header, value) {
        return _super.call(this, "WixHeadersParsingError: " + header + " evaluated with " + JSON.stringify(value) + " but should be a string!") || this;
    }
    return WixHeadersParsingError;
}(Error));
export { WixHeadersParsingError };
var WixHeadersValidationError = /** @class */ (function (_super) {
    __extends(WixHeadersValidationError, _super);
    function WixHeadersValidationError(type, key, value) {
        return _super.call(this, "WixHeadersValidationError: expected " + key + " to be " + type + " but got " + JSON.stringify(value)) || this;
    }
    return WixHeadersValidationError;
}(Error));
export { WixHeadersValidationError };
//# sourceMappingURL=errors.js.map